import React from "react";

/* ── Asset imports ── */
import HeroBgImg         from "../../asset/images/news/IndustrialSMPSSolutionsHero-bg.webp";
import ArticleImg        from "../../asset/images/news/article10.webp";
import YoutubeIcon       from "../../asset/images/news/icon-youtube.svg";
import LinkedinIcon      from "../../asset/images/news/icon-linkedin.svg";
import BcSepIcon         from "../../asset/images/news/breadcrumb-separator.svg";
import ProfileIcon       from "../../asset/images/news/icon-profile.svg";
import CalendarIcon      from "../../asset/images/news/icon-calendar.svg";
import ClockIconImg      from "../../asset/images/news/icon-clock.svg";
import CommentsIcon      from "../../asset/images/news/icon-comments.svg";
import PreviousIcon      from "../../asset/images/news/icon-previous.svg";
import NextIcon          from "../../asset/images/news/icon-next.svg";
import FacebookIcon      from "../../asset/images/news/icon-facebook.svg";
import TwitterIcon       from "../../asset/images/news/icon-twitter.svg";
import LinkedinShareIcon from "../../asset/images/news/icon-linkedin-share.svg";

/* ── Recent post thumbnails ── */
import RecentImg1 from "../../asset/images/news/news-1.webp";
import RecentImg2 from "../../asset/images/news/news-2.webp";
import RecentImg3 from "../../asset/images/news/news-3.webp";
import RecentImg4 from "../../asset/images/news/news-4.webp";

const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800&display=swap');

  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  .iss { font-family: 'Poppins', sans-serif; font-size: 14px; color: #202020; background: #fff; }

  /* ══ HERO ══ */
  .iss-hero {
    position: relative; width: 100%; height: 460px;
    overflow: hidden; 
  }
  .iss-hero-bg {
    position: absolute; inset: 0;
    width: 100%; height: 100%;
    object-fit: cover; object-position: center right; display: block;
  }
  .iss-hero-overlay {
    position: absolute; inset: 0;
    // background: linear-gradient(
    //   to right,
    //   rgba(0,0,0,0.85) 0%,
    //   rgba(0,0,0,0.65) 38%,
    //   rgba(0,0,0,0.10) 100%
    // );
  }
  .iss-hero-content {
    position: absolute; inset: 0;
    display: flex; flex-direction: column; justify-content: center;
    padding: 0 102px;
    max-width: 1600px; margin: 0 auto; left: 0; right: 0;
  }
  .iss-hero-title {
    font-family: 'Poppins', sans-serif;
    font-size: 42px; font-weight: 600; color: #fff;
    line-height: 120%; margin-bottom: 15px; max-width: 575px;
  }
  .iss-hero-divider {
    width: 479px; height: 2px;
    background: #EB2019; border: none; margin-bottom: 15px;
  }
  .iss-hero-subtitle {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #fff;
    line-height: 160%; max-width: 479px;
  }

  /* ══ BREADCRUMB ══ */
  .iss-breadcrumb { width: 100%; padding: 40px 0 0 0; }
  .iss-breadcrumb-inner {
    max-width: 1600px; margin: 0 auto; padding: 0 102px;
    display: flex; align-items: center; flex-wrap: wrap;
  }
  .iss-bc-item {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 500; color: #202020;
    text-decoration: none; display: flex; align-items: center; gap: 14px;
    transition: color 0.15s;
  }
  .iss-bc-item:hover { color: #EB2019; }
  .iss-bc-sep {
    display: flex; align-items: center; justify-content: center;
    width: 24px; height: 24px; border-radius: 50%;
    margin: 0 8px; flex-shrink: 0;
  }
  .iss-bc-sep img { width: 24px; height: 24px; display: block; }
  .iss-bc-item.active { color: #202020; font-weight: 500; }

  /* ══ INNER ══ */
  .iss-inner { max-width: 1600px; margin: 0 auto; padding: 0 102px; }

  /* ══ MAIN ══ */
  .iss-main-section { padding: 80px 0 120px 0; }
  .iss-main-row { display: flex; align-items: flex-start; gap: 89px; }

  /* ══ ARTICLE ══ */
  .iss-article { flex: 1; min-width: 0; }

  .iss-meta-bar {
    display: flex; align-items: center; flex-wrap: wrap; gap: 20px;
    margin-bottom: 30px;
  }
  .iss-meta-item {
    display: flex; align-items: center; gap: 8px;
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    border-right: 1px solid #7A7A7A; padding-right: 15px;
  }
  .iss-meta-item:last-child { border-right: none; padding-right: 0; }
  .iss-meta-item img { width: 24px; height: 24px; display: block; flex-shrink: 0; }

  .iss-article-title {
    font-family: 'Poppins', sans-serif;
    font-size: 32px; font-weight: 600; color: #202020;
    line-height: 140%; margin-bottom: 30px;
  }

  .iss-article-img {
    width: 100%; height: 450px;
    object-fit: cover; border-radius: 10px;
    display: block; margin: 45px 0 30px 0;
  }

  .iss-article-body {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    line-height: 160%;
  }
  .iss-article-body p { margin-bottom: 15px; }
  .iss-article-body p:last-child { margin-bottom: 0; }

  /* Bold headings */
  .iss-h2 {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 600; color: #202020;
    margin: 30px 0 15px 0; line-height: 160%; display: block;
  }

  /* Bullet list */
  .iss-article-body ul {
    list-style: none; margin: 0 0 30px 0; padding: 0;
    display: flex; flex-direction: column; gap: 15px;
  }
  .iss-article-body ul li {
    display: flex; align-items: flex-start; gap: 10px;
    font-size: 16px; font-weight: 400; color: #202020;
    line-height: 160%;
  }
  .iss-article-body ul li::before {
    content: '•'; color: #202020;
    font-size: 16px; line-height: 160%; flex-shrink: 0;
  }
  .iss-article-body ul li > span { flex: 1; }

  /* Application item (bold title + description below) */
  .iss-app-list {
    display: flex; flex-direction: column; gap: 15px;
    margin-bottom: 30px;
  }
  .iss-app-item {
    display: flex; align-items: flex-start; gap: 10px;
    font-size: 16px; color: #202020; line-height: 160%;
    .para{margin-bottom:30px;}
  }
  .iss-app-item::before {
    content: '•'; color: #202020;
    font-size: 16px; line-height: 160%; flex-shrink: 0;
  }
  .iss-app-item-body { display: flex; flex-direction: column; gap: 4px; flex: 1; }
  .iss-app-item-title { font-weight: 600; }
  .iss-app-item-desc { font-weight: 400; }

  .iss-article-body strong { font-weight: 600; color: #202020; }

  .iss-red-link { color: #EB2019; text-decoration: underline; font-weight:600; }
  .iss-red-link:hover { opacity: 0.8; }

  /* Hashtags */
  .iss-hashtags {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    line-height: 160%; margin-top: 15px;
  }

  /* ══ BOTTOM ROW ══ */
  .iss-bottom-row {
    display: flex; align-items: center; justify-content: space-between;
    margin-top: 30px; padding-top: 30px;
    border-top: 1px solid #C7C7C7; flex-wrap: wrap; gap: 16px;
  }
  .iss-bottom-nav { display: flex; align-items: center; gap: 60px; }
  .iss-nav-btn {
    display: inline-flex; align-items: center; gap: 20px;
    font-family: 'Poppins', sans-serif;
    font-size: 20px; font-weight: 500; color: #202020;
    text-decoration: none; background: none; border: none;
    cursor: pointer; transition: color 0.15s;
  }
  .iss-nav-btn:hover { color: #EB2019; }
  .iss-nav-btn img { width: 40px; height: 40px; display: block; }

  .iss-share-icons { display: flex; align-items: center; gap: 20px; }
  .iss-share-icon {
    display: flex; align-items: center; justify-content: center;
    width: 40px; height: 40px; border-radius: 50%;
    text-decoration: none; flex-shrink: 0; transition: opacity 0.15s;
  }
  .iss-share-icon:hover { opacity: 0.85; }
  .iss-share-icon img { width: 44px; height: 44px; display: block; }

  /* ══ SIDEBAR ══ */
  .iss-sidebar { flex: 0 0 475px; }
  .iss-sidebar-block { margin-bottom: 60px; }
  .iss-sidebar-title {
    font-family: 'Poppins', sans-serif;
    font-size: 24px; font-weight: 600; color: #202020;
    margin-bottom: 30px; padding-bottom: 20px;
    border-bottom: 1px solid #EB2019; line-height: 120%;
  }
  .iss-recent-list { display: flex; flex-direction: column; gap: 30px; }
  .iss-recent-item {
    display: flex; align-items: flex-start; gap: 12px;
    text-decoration: none; color: #202020;
  }
  .iss-recent-item:hover .iss-recent-title { color: #EB2019; }
  .iss-recent-img {
    flex: 0 0 200px; height: 120px;
    object-fit: cover; border-radius: 6px; display: block;
  }
  .iss-recent-body { flex: 1; min-width: 0; }
  .iss-recent-title {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    line-height: 160%; transition: color 0.15s;
    display: -webkit-box; -webkit-line-clamp: 3;
    -webkit-box-orient: vertical; overflow: hidden;
  }
  .iss-social-icons { display: flex; align-items: center; gap: 30px; }
  .iss-social-icon {
    display: flex; align-items: center; justify-content: center;
    width: 40px; height: 40px; border-radius: 6px; overflow: hidden;
    text-decoration: none; transition: opacity 0.15s;
  }
  .iss-social-icon:hover { opacity: 0.8; }
  .iss-social-icon img { width: 44px; height: 44px; object-fit: contain; display: block; }

  /* ══ RESPONSIVE — TABLET ══ */
  @media (max-width: 768px) {
    .iss-hero             { height: 350px; }
    .iss-hero-content     { padding: 0 32px; }
    .iss-hero-title       { font-size: 30px; }
    .iss-hero-divider     { width: 100%; max-width: 479px; }
    .iss-breadcrumb       { padding: 24px 0 0 0; }
    .iss-breadcrumb-inner { padding: 0 32px; }
    .iss-inner            { padding: 0 32px; }
    .iss-main-section     { padding: 48px 0 60px 0; }
    .iss-main-row         { flex-direction: column; gap: 48px; }
    .iss-sidebar          { flex: none; width: 100%; }
    .iss-article-title    { font-size: 20px; }
  }

  /* ══ RESPONSIVE — MOBILE ══ */
  @media (max-width: 480px) {
    .iss-hero             { height: 360px; }
    .iss-hero-content     { padding: 0 16px; }
    .iss-hero-title       { font-size: 24px; margin-bottom: 15px; }
    .iss-hero-divider     { width: 100%; }
    .iss-hero-subtitle    { font-size: 14px; }
    .iss-breadcrumb       { padding: 30px 0 0 0; }
    .iss-breadcrumb-inner { padding: 0 16px; }
    .iss-bc-item          { font-size: 14px; gap: 14px; }
    .iss-bc-sep           { width: 18px; height: 18px; margin: 0 4px; }
    .iss-bc-sep img       { width: 22px; height: 22px; }
    .iss-inner            { padding: 0 16px; }
    .iss-main-section     { padding: 30px 0 60px 0; }
    .iss-main-row         { flex-direction: column; gap: 60px; }
    .iss-sidebar          { flex: none; width: 100%; }
    .iss-article-title    { font-size: 20px; margin-bottom: 15px; }
    .iss-article-body     { font-size: 14px ;}
    .iss-article-body ul li { font-size: 14px; }
    .iss-article-body ul { margin: 0 0 15px 0;}
    .iss-app-item-title { font-size: 14px; }
    .iss-app-item-desc { font-size: 14px; }
    .iss-app-list { margin-bottom: 15px;}
    .iss-meta-item        { font-size: 14px; }
    .iss-article-img      { margin: 30px 0 15px 0; height: 250px; }
    .iss-h2               { font-size: 16px; margin: 20px 0 15px 0; }
    .iss-nav-btn img      { width: 24px; height: 24px; }
    .iss-nav-btn          { font-size: 14px; }
    .iss-share-icon img   { width: 34px; height: 34px; }
    .iss-hashtags         { margin-top: 20px; }
  }
`;

const recentPosts = [
  {
    img: RecentImg1,
    title: "Battery Formation & Testing: Enabling The Rise Of EV & Energy Storage Manufacturing",
    slug: "battery-formation-testing-enabling-rise-ev-energy-storage-manufacturing",
  },
  {
    img: RecentImg2,
    title: "Next-Gen ESP Power Supplies: Upgrades and Sustainability in Industrial Air Pollution Control",
    slug: "next-gen-esp-power-supplies-upgrades-sustainability-industrial-air-pollution-control",
  },
  {
    img: RecentImg3,
    title: "Green Hydrogen Power Electronics: Ador Powertron at the Forefront of Electrolyzer Rectifier Setups",
    slug: "green-hydrogen-power-electronics-ador-powertron-forefront-electrolyzer-rectifier-setups",
  },
  {
    img: RecentImg4,
    title: "Transformer Bushings: Types & Importance",
    slug: "transformer-bushings-types-importance",
  },
];

export default function IndustrialSMPSSolutions() {
  return (
    <div className="iss">
      <style>{CSS}</style>

      {/* ══ HERO ══ */}
      <section className="iss-hero">
        <img className="iss-hero-bg" src={HeroBgImg} alt="Industrial SMPS Solutions Hero" />
        <div className="iss-hero-overlay" />
        <div className="iss-hero-content">
          <h1 className="iss-hero-title">
            Industrial SMPS Solutions: Powering the Future of Industrial Automation and Pollution Control
          </h1>
          <hr className="iss-hero-divider" />
          <p className="iss-hero-subtitle">
            Everything we do is designed, whether we're producing a magazine, a website, or a bridge. Design is really the creative invention that designs everything.
          </p>
        </div>
      </section>

      {/* ══ BREADCRUMB ══ */}
      <nav className="iss-breadcrumb" aria-label="Breadcrumb">
        <div className="iss-breadcrumb-inner">
          <a href="/" className="iss-bc-item">Home</a>
          <span className="iss-bc-sep"><img src={BcSepIcon} alt="" /></span>
          <a href="/news" className="iss-bc-item">News &amp; Updates</a>
          <span className="iss-bc-sep"><img src={BcSepIcon} alt="" /></span>
          <span className="iss-bc-item active">Post</span>
        </div>
      </nav>

      {/* ══ MAIN ══ */}
      <section className="iss-main-section">
        <div className="iss-inner">
          <div className="iss-main-row">

            {/* ── ARTICLE ── */}
            <article className="iss-article">

              {/* Meta bar */}
              <div className="iss-meta-bar">
                <span className="iss-meta-item"><img src={ProfileIcon} alt="author" /> Admin</span>
                <span className="iss-meta-item"><img src={CalendarIcon} alt="date" /> May 21, 2025</span>
                <span className="iss-meta-item"><img src={ClockIconImg} alt="time" /> 6:50 am</span>
                <span className="iss-meta-item"><img src={CommentsIcon} alt="comments" /> No Comments</span>
              </div>

              {/* Title */}
              <h1 className="iss-article-title">
                Industrial SMPS Solutions: Powering the Future of Industrial Automation and Pollution Control
              </h1>

              {/* Body */}
              <div className="iss-article-body">

                <p><a href="/smps" className="iss-red-link">Switch Mode Power Supplies (SMPS)</a> have revolutionized how industries manage and distribute power. By converting electrical energy with high efficiency and minimal heat loss, SMPS systems have become the backbone of modern industrial automation. This blog explores the critical role of industrial SMPS solutions, their applications in various sectors, especially pollution control systems, and how to leverage internal linking to enhance SEO and user navigation.</p>

                <p>A Switch Mode Power Supply (SMPS) is an electronic power supply that incorporates a switching regulator to convert electrical power efficiently. Unlike traditional linear power supplies, SMPS offer higher efficiency, compact size, and greater reliability. They are widely used in industrial applications due to their ability to handle variable input voltages and provide stable output.</p>

                {/* Article image */}
                <img className="iss-article-img" src={ArticleImg} alt="Industrial SMPS Power Supply" />

                <span className="iss-h2">Benefits of Industrial SMPS Solutions</span>

                <ul>
                  <li><span><strong>High Efficiency:</strong> SMPS typically operate at efficiencies above 85%, reducing energy loss and operational costs.</span></li>
                  <li><span><strong>Compact Design:</strong> The smaller size and weight make them ideal for space-constrained industrial settings.</span></li>
                  <li><span><strong>Wide Input Voltage Range:</strong> Ideal for environments with fluctuating power supply.</span></li>
                  <li><span><strong>Reliable Performance:</strong> Provides stable and consistent power essential for sensitive industrial equipment.</span></li>
                  <li><span><strong>Heat Management:</strong> Less heat generation reduces the need for extensive cooling systems.</span></li>
                </ul>

                <span className="iss-h2">Types of SMPS Used in Industry</span>

                <ul>
                  <li><span>AC to DC Converters</span></li>
                  <li><span>DC to DC Converters</span></li>
                  <li><span>Flyback Converters</span></li>
                  <li><span>Forward Converters</span></li>
                  <li><span>Push-Pull Converters</span></li>
                  <li><span>Half-Bridge and Full-Bridge Converters</span></li>
                </ul>

                <p>Each type is selected based on the specific power requirements and application scenario.</p>

                <span className="iss-h2">Industrial Applications of SMPS</span>

                <div className="iss-app-list">
                  <div className="iss-app-item">
                    <div className="iss-app-item-body">
                      <span className="iss-app-item-title">Automation and Robotics</span>
                      <span className="iss-app-item-desc">Industrial SMPS systems provide reliable power to automation equipment, PLCs, and robotic systems, ensuring uninterrupted operations.</span>
                    </div>
                  </div>
                  <div className="iss-app-item">
                    <div className="iss-app-item-body">
                      <span className="iss-app-item-title">Manufacturing Equipment</span>
                      <span className="iss-app-item-desc">SMPS are used in CNC machines, laser cutters, and industrial printers for consistent power delivery.</span>
                    </div>
                  </div>
                  <div className="iss-app-item">
                    <div className="iss-app-item-body">
                      <span className="iss-app-item-title">Data Centers and Server Farms</span>
                      <span className="iss-app-item-desc">High-efficiency SMPS solutions are used to power sensitive IT infrastructure, minimizing energy usage and heat generation.</span>
                    </div>
                  </div>
                  <div className="iss-app-item">
                    <div className="iss-app-item-body">
                      <span className="iss-app-item-title">Telecommunication Infrastructure</span>
                      <span className="iss-app-item-desc">SMPS provides clean and uninterrupted power to base stations, communication towers, and network hardware.</span>
                    </div>
                  </div>
                  <div className="iss-app-item">
                    <div className="iss-app-item-body">
                      <span className="iss-app-item-title">Other Industrial Uses</span>
                      <span className="iss-app-item-desc">One of the most critical and evolving applications of industrial SMPS is in pollution control technologies.</span>
                    </div>
                  </div>
                </div>

                <span className="iss-h2">Applications of SMPS in Pollution Control</span>

                <div className="iss-app-list">
                  <div className="iss-app-item">
                    <div className="iss-app-item-body">
                      <span className="iss-app-item-title">Electrostatic Precipitators (ESP)</span>
                      <span className="iss-app-item-desc">SMPS units are used in electrostatic precipitators to provide high-voltage power for capturing particulate matter from industrial exhausts.</span>
                    </div>
                  </div>
                  <div className="iss-app-item">
                    <div className="iss-app-item-body">
                      <span className="iss-app-item-title">Fabric Filters and Baghouses</span>
                      <span className="iss-app-item-desc">SMPS ensures consistent operation of control systems used in managing baghouse filters.</span>
                    </div>
                  </div>
                  <div className="iss-app-item">
                    <div className="iss-app-item-body">
                      <span className="iss-app-item-title">Gas Analyzers</span>
                      <span className="iss-app-item-desc">SMPS powers gas analyzers used in monitoring and controlling emissions in real-time.</span>
                    </div>
                  </div>
                  <div className="iss-app-item">
                    <div className="iss-app-item-body">
                      <span className="iss-app-item-title">Scrubbers and Wet Collectors</span>
                      <span className="iss-app-item-desc">SMPS systems provide stable power for sensors and control units in scrubbing systems that eliminate harmful emissions.</span>
                    </div>
                  </div>
                  <div className="iss-app-item">
                    <div className="iss-app-item-body">
                      <span className="iss-app-item-title">Continuous Emission Monitoring Systems (CEMS)</span>
                      <span className="iss-app-item-desc">CEMS require uninterrupted power to measure SOx, NOx, CO, CO2 and particulate matter; SMPS plays a crucial role here.</span>
                    </div>
                  </div>
                </div>

                <p >Read more on Applications of SMPS in Pollution Control</p>

                <span className="iss-h2">Key Features of High-Quality Industrial SMPS</span>

                <ul>
                  <li><span>Over-voltage protection</span></li>
                  <li><span>Under-voltage protection</span></li>
                  <li><span>Short-circuit protection</span></li>
                  <li><span>Over-temperature shutdown</span></li>
                  <li><span>Load regulation and line regulation</span></li>
                </ul>

                <p>Designing a Custom SMPS Solution</p>

                <span className="iss-h2">When designing a custom SMPS for industrial use, consider the following:</span>

                <ul>
                  <li><span><strong>Load Requirements:</strong> Understand peak and average load requirements.</span></li>
                  <li><span><strong>Thermal Management:</strong> Ensure adequate heat dissipation.</span></li>
                  <li><span><strong>Environmental Conditions:</strong> Account for humidity, dust, and temperature.</span></li>
                  <li><span><strong>Compliance:</strong> Must meet industrial and environmental standards.</span></li>
                </ul>

                <p><a href="/smps-solutions" className="iss-red-link">Explore Custom SMPS Solutions for Industry</a></p>

                <span className="iss-h2">Why Choose Ador Powertron for Industrial SMPS Solutions?</span>

                <p><a href="/about" className="iss-red-link">Ador Powertron</a> is a leader in designing and manufacturing SMPS solutions tailored for industrial and environmental applications. Our expertise spans over decades, ensuring reliable, innovative, and efficient power solutions for industries ranging from cement and steel to power and pollution control.</p>

                <span className="iss-h2">Advantages:</span>

                <ul>
                  <li><span>Proven track record</span></li>
                  <li><span>In-house R&amp;D</span></li>
                  <li><span>Customization capability</span></li>
                  <li><span>Dedicated support team</span></li>
                </ul>

                <p><a href="/smps-products" className="iss-red-link">Learn more about Ador Powertron's Industrial SMPS Products</a></p>

                <span className="iss-h2">Conclusion</span>

                <p><a href="/smps" className="iss-red-link">Industrial SMPS</a> solutions are essential for ensuring energy-efficient and reliable power in a wide range of applications. Their role in pollution control systems highlights the versatility and importance of these systems in meeting both operational and environmental goals. Companies like Ador Powertron continue to lead the way in providing cutting-edge SMPS technology that powers industry while protecting the planet.</p>

                <p><a href="/contact" className="iss-red-link">Contact us to discuss your SMPS needs</a></p>

                <p className="iss-hashtags">#smpspower #switchmodepowersupply #smps #adorpower #smpssolutions</p>

              </div>

              {/* ── Bottom row ── */}
              <div className="iss-bottom-row">
                <div className="iss-bottom-nav">
                  <a href="/news/previous" className="iss-nav-btn">
                    <img src={PreviousIcon} alt="Previous" />
                    Previous
                  </a>
                  <a href="/news/next" className="iss-nav-btn">
                    Next
                    <img src={NextIcon} alt="Next" />
                  </a>
                </div>
                <div className="iss-share-icons">
                  <a href="#" className="iss-share-icon" aria-label="Facebook">
                    <img src={FacebookIcon} alt="Facebook" />
                  </a>
                  <a href="#" className="iss-share-icon" aria-label="Twitter">
                    <img src={TwitterIcon} alt="Twitter" />
                  </a>
                  <a href="#" className="iss-share-icon" aria-label="LinkedIn">
                    <img src={LinkedinShareIcon} alt="LinkedIn" />
                  </a>
                </div>
              </div>

            </article>

            {/* ── SIDEBAR ── */}
            <aside className="iss-sidebar">

              {/* Recent Posts */}
              <div className="iss-sidebar-block">
                <p className="iss-sidebar-title">Recent Posts</p>
                <div className="iss-recent-list">
                  {recentPosts.map((post, idx) => (
                    <a key={idx} href={`/news/${post.slug}`} className="iss-recent-item">
                      <img src={post.img} alt={post.title} className="iss-recent-img" />
                      <div className="iss-recent-body">
                        <span className="iss-recent-title">{post.title}</span>
                      </div>
                    </a>
                  ))}
                </div>
              </div>

              {/* Social Media */}
              <div className="iss-sidebar-block">
                <p className="iss-sidebar-title">Social Media</p>
                <div className="iss-social-icons">
                  <a href="#" className="iss-social-icon" aria-label="YouTube">
                    <img src={YoutubeIcon} alt="YouTube" />
                  </a>
                  <a href="#" className="iss-social-icon" aria-label="LinkedIn">
                    <img src={LinkedinIcon} alt="LinkedIn" />
                  </a>
                </div>
              </div>

            </aside>

          </div>
        </div>
      </section>

    </div>
  );
}